import "./bootstrap.scss";
import $ from "dabbyjs/src/core/dabby/dabby.js";
import "./swgfl/javascript/accessibility.js";
import cookies from "./swgfl/cookies/javascript/cookies.js";
import security from "./swgfl/security/javascript/all.js";
import cms from "./swgfl/cms/javascript/cms.js";
import forms from "./swgfl/forms/javascript/forms.js";

$(() => {
	cookies($(".cookies"));
	security();
	cms($("#form-cms"));
	forms();
});